import React from 'react';
import { Button, Stack } from '@mui/material';

export const ModalActions = ({
  onCancel,
  onDraft,
  onSubmit,
  submitLabel = 'Submit',
  disabled = false,
}) => (
  <Stack direction="row" gap={2} justifyContent="center">
    <Button variant="outlined" color="primary" onClick={onCancel} disabled={disabled}>
      Cancel
    </Button>
    {onDraft && (
      <Button variant="outlined" color="primary" onClick={onDraft} disabled={disabled}>
        Save as draft
      </Button>
    )}
    <Button variant="contained" color="primary" onClick={onSubmit} disabled={disabled}>
      {submitLabel}
    </Button>
  </Stack>
);

export const InfoRow = ({ label, value, note }) => (
  <Stack direction="row" gap={0.5} flexWrap="wrap" component="p" m={0} fontSize="0.875rem">
    <strong>{label}:</strong>
    <span>{value}</span>
    {note && <span style={{ color: 'rgba(0, 0, 0, 0.6)' }}>({note})</span>}
  </Stack>
);

export const textAreaSx = { '& .MuiInputBase-root': { p: 0 } };
